(function () {
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-dn-ids]') : null;
    if (!b) return;
    var items = b.getAttribute('data-dn-ids').split(',').filter(Boolean).map(function (id) {
      return { id: Number(id), quantity: 1 };
    });
    if (!items.length) return;
    b.disabled = true;
    fetch(b.getAttribute('data-dn-add'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw 0;
      window.location.href = b.getAttribute('data-dn-cart');
    }).catch(function () {
      b.disabled = false;
      b.textContent = 'Alcuni capi non sono piu disponibili';
    });
  });
})();
